var map = {
	"./ar.svg": 6700,
	"./bo.svg": 3035,
	"./br.svg": 6097,
	"./cl.svg": 1253,
	"./co.svg": 8650,
	"./cr.svg": 2022,
	"./ec.svg": 4262,
	"./mx.svg": 4994,
	"./pe.svg": 3638,
	"./us.svg": 5117,
	"./uy.svg": 9436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4983;